// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"style_dashboardContainer__V8zWY"};